import React, { useEffect } from 'react';

import LogoLoader from 'components/Loader/LogoLoader';
import { useLogout } from 'hooks/auth/useLogout';

const Logout: React.FC<unknown> = () => {
  const handleLogout = useLogout();

  useEffect(() => {
    handleLogout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LogoLoader />;
};

export default Logout;
